import { getLanguageCodeFromLanguageRegionCode } from '../utils/languageTypeModifiers';
import { useLanguageRegionCode } from './useLanguageRegionCode';

export function useLanguageCode() {
  const languageRegionCode = useLanguageRegionCode();
  return getLanguageCodeFromLanguageRegionCode(languageRegionCode);
}
